import styled from 'styled-components';

const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
`;

export default ActionsContainer;
